<template>
  <div>
    <div class="d-flex justify-content-between mb-3">
      <div>Status: <span style="min-width: 10em;" class="d-inline-block">{{ Status }}</span></div>
    </div>

    <div class="row">
      <div class="col-6">
        <label for="RaisedDate" class="d-block">
          Raised Date
          <el-date-picker
            v-model="Received"
            format="dd.MM.yyyy"
            value-format="yyyy-MM-dd"
            class="float-right"
            type="date"
            disabled
          ></el-date-picker>
        </label>
      </div>
      <div class="col-6">
        <label for="ContactDate" class="d-block">
          Contact Date
          <el-date-picker
            v-model="CustomerContactDate"
            format="dd.MM.yyyy"
            value-format="yyyy-MM-dd"
            class="float-right"
            type="date"
            disabled
          ></el-date-picker>
        </label>
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <label for="InitatingSupplier" class="d-block">
          Initating Supplier
          <b-form-input v-model="InitiatingSupplierId" type="text" disabled/>
        </label>
      </div>
      <div class="col-6">
        <label for="AssociatedSupplier" class="d-block">
          Associated Supplier
          <b-form-input v-model="AssociatedSupplierId" type="text" disabled/>
        </label>
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <label for="GainingSupplier" class="d-block">
          Gaining Supplier
          <b-form-input v-model="GainingSupplierId" type="text" disabled/>
        </label>
      </div>
      <div class="col-6">
        <label for="LosingSupplier" class="d-block">
          Losing Supplier
          <b-form-input v-model="LosingSupplierId" type="text" disabled/>
        </label>
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <label for="CustomerName" class="d-block">
          Customer Name
          <b-form-input v-model="CustomerName" type="text" disabled/>
        </label>
      </div>
      <div class="col-6">
        <label for="Telephone" class="d-block">
          Telephone
          <b-form-input v-model="CustomerTelephone" type="text" disabled/>
        </label>
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <label for="ReasonForReturn" class="d-block">
          Reason For Return
          <b-form-input v-model="ReturnReason" type="text" disabled/>
        </label>
      </div>
      <div class="col-6">
        <label for="SSD" class="d-block">
          SSD
          <b-form-input v-model="supplyStartDate" type="text" disabled/>
        </label>
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <label for="SED" class="d-block">
          SED
          <b-form-input v-model="supplyEndDate" type="text" disabled/>
        </label>
      </div>
    </div>
    
    <div class="row my-3">
      <div class="col">
        <label for="AdditionalInformation" class="d-block">
          Additional Information
          <textarea v-model="InitiationAdditionalInformation" name="" id="" style="width: 100%;" rows="6" class="d-block" disabled></textarea>
        </label>
      </div>
    </div>

    <div>
      <input type="checkbox" name="NoContact" id="" class="mr-3" disabled>
      No Contact
    </div>
    <div>
      <input v-model="accepted" type="checkbox" name="Accept" id="" class="mr-3" :disabled="viewOnly">
      Accept
    </div>
    <div>
      <input v-model="rejected" type="checkbox" name="Reject" id="" class="mr-3" :disabled="viewOnly">
      Reject
    </div>

    <div v-if="!viewOnly" class="mt-3">
      <button class="btn btn-hc mr-3" 
      data-dismiss="modal"
      data-target="#ViewET"
      :disabled="accepted == rejected" @click="respond">Submit</button>
      <button class="btn" 
      data-dismiss="modal"
      data-target="#ViewET"
      @click="p_status = null">Cancel</button>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import Vue from 'vue';

export default {
  name: 'EtViewElectricity',

  props: {
    viewOnly: { type: Boolean },

    Id: { type: String },
    SharedId: { type: String },

    Status: { type: String },
    RejectionOrAcceptanceCode: { type: String },

    Received: { type: String },
    CustomerContactDate: { type: String },

    ReturnReason: { type: String },

    CustomerName: { type: String },
    CustomerTelephone: { type: String },

    InitiatingSupplierId: { type: String },
    AssociatedSupplierId: { type: String },
    LosingSupplierId: { type: String },
    GainingSupplierId: { type: String },

    InitiationAdditionalInformation: { type: String },
    ReplyAdditionalInformation: { type: String },

    NoContact: { type: Boolean },

    Registration: { type: Object },
  },

  data() {
    return {
      p_status: undefined,
    };
  },

  computed: {
    form: {
      get() {
        return {
          SharedId: this.SharedId,
          Status: this.p_status,
          AdditionalInformation: undefined,
        };
      },
    },

    accepted: {
      get() {
        return /Accepted/.test(this.p_status || this.Status);
      },
      set(val) {
        if (val) {
          if (this.AssociatedSupplierId === this.GainingSupplierId)
            this.p_status = 'AcceptedByNew';
          else this.p_status = 'AcceptedByOld';
        } else {
          this.p_status = undefined;
        }
      },
    },

    rejected: {
      get() {
        return /Rejected/.test(this.p_status || this.Status);
      },
      set(val) {
        if (val) {
          if (this.AssociatedSupplierId === this.GainingSupplierId)
            this.p_status = 'RejectedByNew';
          else this.p_status = 'RejectedByOld';
        } else {
          this.p_status = undefined;
        }
      },
    },

    statusMapped() {
      return {
        ProposedByNew: 'P',
        AcceptedByNew: 'A',
        RejectedByNew: 'R',
        ProposedByOld: 'Q',
        AcceptedByOld: 'A',
        RejectedByOld: 'N',
        RejectedInitiationWindowExpired: 'T',
      }[this.Status];
    },

    mapper() {
      return {
        ProposedByNew: 'P',
        AcceptedByNew: 'A',
        RejectedByNew: 'R',
        ProposedByOld: 'Q',
        AcceptedByOld: 'A',
        RejectedByOld: 'N',
        RejectedInitiationWindowExpired: 'T',
      };
    },

    supplyStartDate: {
      get() {
        return (
          this.Registration &&
          this.Registration.EffectiveFrom &&
          moment(this.Registration.EffectiveFrom).format('ll')
        );
      },
      set() {},
    },

    supplyEndDate: {
      get() {
        return (
          (this.Registration &&
            this.Registration.EffectiveTo &&
            moment(this.Registration.EffectiveTo).format('ll')) ||
          'Ongoing'
        );
      },
      set() {},
    },

    flowbot() {
      return Vue.config.honeycomb.flowbot.electricity.domain;
    },
  },

  methods: {
    toDate(date) {
      return moment(date).format('ll');
    },

    async respond() {
      try {
        await this.$http.put(
          `https://${this.flowbot}/api/v1/erroneoustransfers/${this.SharedId}`,
          this.form,
          { withCredentials: true }
        );

        this.p_status = undefined;

        this.$snotify.success('ET Updated', {
          timeout: 20000,
          closeOnClick: true,
        });
      } catch (err) {
        this.$snotify.error(`${err.response.data.UserDescription}`, {
          timeout: 0,
          closeOnClick: true,
        });
      } finally {
        this.$emit('refresh');
      }
    },
  },
};
</script>

<style>
label {
  text-wrap: nowrap;
}
</style>
